export const compose =
  (...higherOrderComponents) =>
  (component) =>
    higherOrderComponents.reduceRight(
      (accumulatedComponent, higherOrderComponent) => higherOrderComponent(accumulatedComponent),
      component
    );
